import { useEffect } from 'react'

/** Escape and click-outside dismissal for a popover anchored to a button. */
export default function usePopover(ref, open, onClose) {
  useEffect(() => {
    if (!open) return undefined

    function onKeyDown(e) {
      if (e.key === 'Escape') {
        e.stopPropagation()
        onClose()
      }
    }
    function onPointerDown(e) {
      if (ref.current && !ref.current.contains(e.target)) onClose()
    }

    document.addEventListener('keydown', onKeyDown)
    document.addEventListener('mousedown', onPointerDown)
    return () => {
      document.removeEventListener('keydown', onKeyDown)
      document.removeEventListener('mousedown', onPointerDown)
    }
  }, [ref, open, onClose])
}
